import type { ReactNode } from 'react';
import { Eye, EyeOff } from 'lucide-react';

import { OlhinhoContext, useOlhinho } from './contexto';
import { useValoresOcultos } from './useValoresOcultos';

/**
 * Liga o olhinho numa tela. Envolve a página INTEIRA (cards, listas, gráficos
 * e diálogos dela), senão o que ficar de fora mostra o número de verdade.
 *
 * O estado não é da tela: todos os provedores leem a mesma memória (um olho
 * só para o app), então esconder aqui esconde em todas as telas cobertas.
 */
export const ValoresOcultosProvider = ({ children }: { children: ReactNode }) => {
  const estado = useValoresOcultos();
  return <OlhinhoContext.Provider value={{ ativo: true, ...estado }}>{children}</OlhinhoContext.Provider>;
};

/**
 * O botão do olho, ao lado do título. O ícone diz o que ESTÁ na tela: olho
 * riscado = números escondidos, olho aberto = visíveis. Fora de um provedor
 * não aparece.
 */
export const BotaoOlhinho = ({ className = '' }: { className?: string }) => {
  const { ativo, oculto, alternar } = useOlhinho();
  if (!ativo) return null;
  const rotulo = oculto ? 'Mostrar valores' : 'Esconder valores';
  return (
    <button
      type="button"
      onClick={alternar}
      aria-label={rotulo}
      title={rotulo}
      data-oculto={oculto ? 'sim' : 'nao'}
      className={`inline-flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-lg text-[#6b7480] transition-colors hover:bg-[rgba(53,70,96,0.07)] hover:text-foreground dark:text-muted-foreground ${className}`}
    >
      {oculto ? (
        <EyeOff className="h-[18px] w-[18px]" data-icone="olho-riscado" aria-hidden />
      ) : (
        <Eye className="h-[18px] w-[18px]" data-icone="olho-aberto" aria-hidden />
      )}
    </button>
  );
};
